import { NgModule } from '@angular/core';
import { AppsSharedModule, BaseAuthModule, BaseSharedModule } from 'base';
import { RouterLink } from '@angular/router';
import { BaseCustomerLoginFormComponent } from './login-form/login-form.component';
import { BaseCustomerMagicLinkLoginComponent } from './magic-link-login/magic-link-login.component';
import { BaseCustomerOnboardingModule } from '../onboarding/onboarding.module';

@NgModule({
  declarations: [BaseCustomerLoginFormComponent, BaseCustomerMagicLinkLoginComponent],
  imports: [BaseSharedModule, RouterLink, BaseAuthModule, BaseCustomerOnboardingModule, AppsSharedModule],
  exports: [BaseCustomerLoginFormComponent, BaseCustomerMagicLinkLoginComponent],
})
export class BaseCustomerAuthModule {}
